import React, { useState, useEffect } from 'react';
import '../styles/MobileParking.css';

const MobileParking = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const googleMapsUrl = "https://www.google.fr/maps/place/72+Av.+Gustave+Eiffel,+37390+Notre-Dame-d'Oé/@47.4388149,0.6961438,16z/data=!3m1!4b1!4m6!3m5!1s0x47fcd4d7a65478b3:0x48faf86176f4595b!8m2!3d47.4388113!4d0.6987187!16s%2Fg%2F11c4cgmptj?entry=ttu&g_ep=EgoyMDI1MDkxNy4wIKXMDSoASAFQAw%3D%3D";
  
  const images = [
    { src: '/img/parc1.webp', alt: 'Parc automobile 1' },
    { src: '/img/parc2.webp', alt: 'Parc automobile 2' },
  ];

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  // Gestion du swipe
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const handleTouchStart = (e) => {
    setTouchStart(e.touches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.touches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) {
      setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    }
    if (isRightSwipe) {
      setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    }

    setTouchStart(null);
    setTouchEnd(null);
  };

  return (
    <div className="mobile-parking">
      <p className="carousel-instruction">
        Cliquez sur l'image pour voir sur Google Maps
      </p>
      <div 
        className="carousel-container"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <button 
          className="carousel-nav prev" 
          onClick={prevSlide}
          aria-label="Image précédente"
        >
          ‹
        </button>
        <button 
          className="carousel-nav next" 
          onClick={nextSlide}
          aria-label="Image suivante"
        >
          ›
        </button>
        <div 
          className="carousel-track" 
          style={{ 
            transform: `translateX(-${currentIndex * 100}%)`,
          }}
        >
          {images.map((image, index) => (
            <div key={index} className="carousel-slide">
              <a href={googleMapsUrl} target="_blank" rel="noopener noreferrer">
                <img src={image.src} alt={image.alt} />
              </a>
            </div>
          ))}
        </div>
        <div className="carousel-dots">
          {images.map((_, index) => (
            <button
              key={index}
              className={`dot ${currentIndex === index ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index)}
              aria-label={`Voir l'image ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default MobileParking;
